export const colors = {
  primary: {
    selected: 'rgb(141, 212, 209)',  // Teal color for selected items
    background: 'rgb(224, 234, 254)', // Light blue for backgrounds
    hover: 'rgb(197, 214, 248)',      // Hover state color
  }
};

export default colors; 